export class SortOption {
    constructor(protected key: string, public asc = true) {}
    value(): string {
        return (this.asc ? '' : '-') + this.key;
    }
}
